import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriAddToSavedCartComponent } from '../../components/gonvarri-add-to-saved-cart/gonvarri-add-to-saved-cart.component';
import {FeaturesConfigModule, I18nModule, provideConfig, provideDefaultConfig, UrlModule} from "@spartacus/core";
import {RouterLink} from "@angular/router";
import {
  defaultSavedCartFormLayoutConfig,
  gonvarriDefaultAddToSavedCartLayoutConfig
} from "../../layouts/add-to-saved-cart-layout-config";
import { GonvarriSavedCartFormDialogComponent } from '../../components/gonvarri-saved-cart-form-dialog/gonvarri-saved-cart-form-dialog.component';
import {FormErrorsModule, IconModule, KeyboardFocusModule} from "@spartacus/storefront";
import {ReactiveFormsModule} from "@angular/forms";
import {CartBaseCoreModule} from "@spartacus/cart/base/core";
import {CartBaseOccModule} from "@spartacus/cart/base/occ";
import {SavedCartCoreModule} from "@spartacus/cart/saved-cart/core";
import {SavedCartOccModule} from "@spartacus/cart/saved-cart/occ";
import {GonvarriCartAdapter} from "../../core/adapters/gonvarri-cart.adapter";
import {GonvarriSavedCartService} from "../../core/services/gonvarri-saved-cart.service";

@NgModule({
  declarations: [
    GonvarriAddToSavedCartComponent,
    GonvarriSavedCartFormDialogComponent
  ],
  imports: [
    CommonModule,
    UrlModule,
    I18nModule,
    RouterLink,
    FeaturesConfigModule,
    KeyboardFocusModule,
    ReactiveFormsModule,
    FormErrorsModule,
    IconModule
  ],
  providers: [
    GonvarriCartAdapter,
    GonvarriSavedCartService,
    provideConfig({
      cmsComponents: {
        AddToSavedCartsComponent: {
          component: GonvarriAddToSavedCartComponent,
        }
      }
    }),
    provideDefaultConfig(gonvarriDefaultAddToSavedCartLayoutConfig),
    provideConfig(defaultSavedCartFormLayoutConfig),
  ]
})
export class GonvarriAddToSavedCartModule { }
